<template>
  <skeleton-theme
    :color="skeletonColor"
    :highlight="skeletonHighlight"
    class="skeleton-loader-group"
  >
    <slot />
    <slot :customStyle="customStyle" name="skeleton" />
  </skeleton-theme>
</template>

<script>
export default {
  data() {
    return {
      skeletonColor: '#E6E9F3',
      skeletonHighlight: '#EDEFF6',
      customStyle: `background-color: ${this.skeletonColor}; background-image: linear-gradient(90deg, ${this.skeletonColor}, ${this.skeletonHighlight}, ${this.skeletonColor}); animation: 1.5s ease-in-out 0s infinite normal none running SkeletonLoading;`
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.skeleton-loader-group {
  ::v-deep .pu-skeleton {
    border-radius: 1px;
  }
  ::v-deep .ico.chart {
    position: absolute;
    top: auto;
    bottom: 0;

    @media screen and (min-width: @screensize-sm) {
      .lh-transform(scaleX(2.5));
      .lh-transform-origin(top left);
    }
  }
}
</style>
